/** Member-facing product names from the approved change request. */
export function subscriptionPlanName(plan: { readonly planCode: string; readonly planName: string }): string {
  if (plan.planCode === "BASIC") return "베이직";
  if (plan.planCode === "PREMIUM") return "프리미엄";
  return plan.planName;
}

/** Server periods have an exclusive end; display the last included business date. */
export function billingPeriod(startsOn?: string | null, endsOn?: string | null): string {
  if (!startsOn || !endsOn) return "기간 확인 중";
  const last = new Date(`${endsOn}T00:00:00Z`);
  last.setUTCDate(last.getUTCDate() - 1);
  return `${startsOn.replaceAll("-", ".")} ~ ${last.toISOString().slice(0, 10).replaceAll("-", ".")}`;
}
